import { createContext, ReactNode, useContext, useState } from 'react';

const MessageContext = createContext<{
  content: string | null;
  setContent: (content: string | null) => void;
  file: File | null;
  setFile: (f: File | null) => void;
} | null>(null);

export function MessageProvider({ children }: { children: ReactNode }) {
  const [content, setContent] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);

  return <MessageContext.Provider value={{ content, setContent, file, setFile }}>{children}</MessageContext.Provider>;
}

export const useMessageContext = () => useContext(MessageContext)!;
